/* unplugin-vue-components disabled */import script from "./WOApostleList.vue?vue&type=script&setup=true&lang=js"
export * from "./WOApostleList.vue?vue&type=script&setup=true&lang=js"

import "./WOApostleList.vue?vue&type=style&index=0&id=6a990e03&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a990e03"]])

export default __exports__